/**
 * @param {number} x
 * @param {number} y
 * @returns {boolean}
 */
export const needsWebMercatorConversion = (x, y) =>
  typeof x === 'number' &&
  typeof y === 'number' &&
  (x < -180 || x > 180 || y < -90 || y > 90);
